import { BilletsBetweenCobblesPage } from "../../pages/reports/billets-between-cobbles/BilletsBetweenCobblesPage";
import { BilletsProcessDataPage } from "../../pages/reports/billets-process-data/BilletsProcessDataPage";
import { BilletWorkOrdersPage } from "../../pages/reports/billet-work-orders/BilletWorkOrdersPage";
import { CobblesReportPage } from "../../pages/reports/cobbles-report/CobblesReportPage";
import { FirstTurnedRollsPage } from "../../pages/reports/first-turned-rolls/FirstTurnedRollsPage";
import { ForecastReportPage } from "../../pages/reports/forecast-report/ForecastReportPage";
import { LastTurnedRollsPage } from "../../pages/reports/last-turned-rolls/LastTurnedRollsPage";
import { RollTurnHistoryDetailPage } from "../../pages/reports/roll-turn-history-detail/RollTurnHistoryDetailPage";
import { NewRollsPage } from "../../pages/reports/new-rolls/NewRollsPage";
import { PartialRollsetsPage } from "../../pages/reports/partial-rollsets/PartialRollsetsPage";
import { RollsInUsePage } from "../../pages/reports/rolls-in-use/RollsInUsePage";
import { PassChangesPage } from "../../pages/reports/pass-changes/PassChangesPage";
import { ProductsHistoryPage } from "../../pages/reports/products-history/ProductsHistoryPage";
import { ProductsWithNoRecipePage } from "../../pages/reports/products-with-no-recipe/ProductsWithNoRecipePage";
import { GasConsumptionPage } from "../../pages/reports/gas-consumption/GasConsumptionPage";
import { InformationRetrievalPage } from "../../pages/reports/information-retrieval/InformationRetrievalPage";
import { ReturnedRollsPage } from "../../pages/reports/returned-rolls/ReturnedRollsPage";
import { RMShiftReportPage } from "../../pages/reports/rm-shift-report/RMShiftReportPage";
import { RollLayoutsPage } from "../../pages/reports/roll-layouts/RollLayoutsPage";
import { RollsPage } from "../../pages/reports/rollshop-operations/RollsPage";
import { RollsetsPage } from "../../pages/reports/rollshop-operations/RollsetsPage";
import { RollshopPage } from "../../pages/reports/rollshop-operations/RollshopPage";
import { StraightenerInformationRetrievalPage } from "../../pages/reports/straightener-information-retrieval/StraightenerInformationRetrievalPage";
import { StraightenerRunsPage } from "../../pages/reports/straightener-runs/StraightenerRunsPage";
import { TimerSpeedReportPage } from "../../pages/reports/timer-speed-report/TimerSpeedReportPage";
import { KPIShiftReportPage } from "../../pages/reports/kpi-shift-report/KPIShiftReportPage";
import { ProductTypesStatisticsPage } from "../../pages/reports/product-types-statistics/ProductTypesStatisticsPage";
import { ShiftsPage } from "../../pages/reports/shifts/ShiftsPage";
import { ProductChangesReportPage } from "../../pages/reports/product-changes-report/ProductChangesReportPage";
import { StraightenerKpisPage } from "../../pages/reports/straightener-kpis/StraightenerKpisPage";
import { RFactorPerStandPage } from "../../pages/reports/rfactor-per-stand/RFactorPerStandPage";
import { SummaryByCloseDatePage } from "../../pages/reports/summary-by-close-date/SummaryByCloseDatePage";

export const routeRolls = "/reports/rolls";
export const routeRollsets = "/reports/rollsets";
export const routeRollshop = "/reports/rollshop";
export const routeRollLayouts = "/reports/roll-layouts";
export const routeCobblesReport = "/reports/cobbles-report";
export const routeRMShiftReport = "/reports/rm-shift-report";
export const routeBilletsProcessData = "/reports/billets-process-data";
export const routeBilletsBetweenCobbles = "/reports/billets-between-cobbles";
export const routeBilletWorkOrders = "/reports/billet-work-orders";
export const routeForecastReport = "/reports/forecast-report";
export const routeGasConsumption = "/reports/gas-consumption";
export const routeInformationRetrieval = "/reports/information-retrieval";
export const routeStraightenerRuns = "/reports/straightener-runs";
export const routeStraightenerInformationRetrieval =
	"/reports/straightener-information-retrieval";
export const routeFirstTurnedRolls = "/reports/first-turned-rolls";
export const routeLastTurnedRolls = "/reports/last-turned-rolls";
export const routeRollTurnHistoryDetail = "/reports/roll-turn-history-detail";
export const routeNewRolls = "/reports/new-rolls";
export const routePartialRollsets = "/reports/partial-rollsets";
export const routeReturnedRolls = "/reports/returned-rolls";
export const routeRollsInUse = "/reports/rolls-in-use";
export const routePassChanges = "/reports/pass-changes";
export const routeProductsWithNoRecipe = "/reports/products-with-no-recipe";
export const routeProductsHistory = "/reports/products-history";
export const routeTimerSpeedReport = "/reports/timer-speed-report";
export const routeKpiShiftReport = "/reports/kpi-shift-report";
export const routeProductTypesStatistics = "/reports/product-types-statistics";
export const routeShifts = "/reports/shifts";
export const routeProductChangesReport = "/reports/product-changes-report";
export const routeStraightenerKpis = "/reports/straightener-kpis";
export const routeRFactorPerStand = "/reports/rfactor-per-stand";
export const routeSummaryByCloseDate = "/reports/summary-by-close-date";

export const reportsRoutes = [
	{
		path: routeRolls,
		element: <RollsPage />,
	},
	{
		path: routeRollsets,
		element: <RollsetsPage />,
	},
	{
		path: routeRollshop,
		element: <RollshopPage />,
	},
	{
		path: routeRollLayouts,
		element: <RollLayoutsPage />,
	},
	{
		path: `${routeRollLayouts}/:standId`,
		element: <RollLayoutsPage />,
	},
	{
		path: routeCobblesReport,
		element: <CobblesReportPage />,
	},
	{
		path: routeRMShiftReport,
		element: <RMShiftReportPage />,
	},
	{
		path: routeBilletsProcessData,
		element: <BilletsProcessDataPage />,
	},
	{
		path: routeBilletsBetweenCobbles,
		element: <BilletsBetweenCobblesPage />,
	},
	{
		path: routeBilletWorkOrders,
		element: <BilletWorkOrdersPage />,
	},
	{
		path: routeInformationRetrieval,
		element: <InformationRetrievalPage />,
	},
	{
		path: routeGasConsumption,
		element: <GasConsumptionPage />,
	},
	{
		path: routeStraightenerRuns,
		element: <StraightenerRunsPage />,
	},
	{
		path: routeStraightenerInformationRetrieval,
		element: <StraightenerInformationRetrievalPage />,
	},
	{
		path: routeFirstTurnedRolls,
		element: <FirstTurnedRollsPage />,
	},
	{
		path: routeLastTurnedRolls,
		element: <LastTurnedRollsPage />,
	},
	{
		path: routeRollTurnHistoryDetail,
		element: <RollTurnHistoryDetailPage />,
	},
	{
		path: `${routeRollTurnHistoryDetail}/:rollName`,
		element: <RollTurnHistoryDetailPage />,
	},
	{
		path: routeNewRolls,
		element: <NewRollsPage />,
	},
	{
		path: routePartialRollsets,
		element: <PartialRollsetsPage />,
	},
	{
		path: routeReturnedRolls,
		element: <ReturnedRollsPage />,
	},
	{
		path: routeRollsInUse,
		element: <RollsInUsePage />,
	},
	{
		path: routePassChanges,
		element: <PassChangesPage />,
	},
	{
		path: routeProductsWithNoRecipe,
		element: <ProductsWithNoRecipePage />,
	},
	{
		path: routeProductsHistory,
		element: <ProductsHistoryPage />,
	},
	{
		path: routeTimerSpeedReport,
		element: <TimerSpeedReportPage />,
	},
	{
		path: routeRFactorPerStand,
		element: <RFactorPerStandPage />,
	},
	{
		path: routeKpiShiftReport,
		element: <KPIShiftReportPage />,
	},
	{
		path: routeProductTypesStatistics,
		element: <ProductTypesStatisticsPage />,
	},
	{
		path: routeForecastReport,
		element: <ForecastReportPage />,
	},
	{
		path: `${routeForecastReport}/:startYear`,
		element: <ForecastReportPage />,
	},
	{
		path: `${routeForecastReport}/:startYear/:endYear`,
		element: <ForecastReportPage />,
	},
	{
		path: routeShifts,
		element: <ShiftsPage />,
	},
	{
		path: routeProductChangesReport,
		element: <ProductChangesReportPage />,
	},
	{
		path: routeStraightenerKpis,
		element: <StraightenerKpisPage />,
	},
	{
		path: routeSummaryByCloseDate,
		element: <SummaryByCloseDatePage />,
	},
];
